import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('core-details-page', {
    attrs: {
      "fetch-item": _vm.fetchDriver,
      "external-fetch-params": {
        driverId: _vm.driverId
      },
      "external-is-changed": _vm.isCopyPasteAction,
      "headline": _vm.headline,
      "subtitle": _vm.subtitle,
      "tabs": _vm.tabs,
      "edit-mode": !_vm.pageIsReadOnly,
      "parent-href": "/virtual-device-drivers",
      "save-item": _vm.saveItem,
      "header-buttons": _vm.headerButtons,
      "item-name": _vm.$i18n_t('DeviceDriver.details.itemName')
    },
    on: {
      "item-change-state": newState => _vm.driverIsChanged = newState
    },
    scopedSlots: _vm._u([{
      key: "image",
      fn: function (slotProps) {
        return [_c(VSelect, {
          attrs: {
            "value": slotProps.item.image,
            "items": _vm.get(slotProps.item, 'properties.attachments', []).map(i => ({
              text: i.name,
              value: i.id
            })),
            "label": _vm.$i18n_t('DeviceDriver.details.tabs.metaInformation.sections.deviceImage.fields.image')
          },
          on: {
            "input": slotProps.emitInput
          }
        }), _c('div', {
          staticClass: "image-upload-wrapper"
        }, [_c('img', {
          staticClass: "image-upload-img",
          attrs: {
            "src": _vm.getDeviceImage(slotProps.item)
          }
        })])];
      }
    }, {
      key: "attachments",
      fn: function (slotProps) {
        return [_c('core-dtwin-attachments', {
          attrs: {
            "source": "devicedriver",
            "attachments": _vm.get(slotProps.item, 'properties.attachments', []),
            "api-version": 2,
            "disabled": _vm.pageIsReadOnly
          },
          on: {
            "update": slotProps.emitInput
          }
        })];
      }
    }, {
      key: "packetParserConfigurator",
      fn: function (slotProps) {
        return [_c('niota-classic-devicetypes-packet-parser-wrapper', {
          attrs: {
            "deviceTypeData": {
              ..._vm.getActiveVersion(slotProps.item),
              account: {
                id: slotProps.item.accountId || -1
              }
            },
            "hide-save-btn": "",
            "emit-instead-of-save": true,
            "hide-predefined-parser-selection": "",
            "readonly": _vm.pageIsReadOnly,
            "custom-test-function": _vm.deviceDriverParserTester(slotProps)
          },
          on: {
            "save-parser": newParserConfig => {
              _vm.onSaveParser(newParserConfig, slotProps);
            }
          }
        })];
      }
    }, {
      key: "linkedDevices",
      fn: function () {
        return [_c('core-virtual-device-list', {
          attrs: {
            "searchTypes": _vm.searchTypes,
            "predefined-search": _vm.linkedDevicesPredefinedSearch,
            "favourite-filter-enabled": false,
            "restoreFilter": false
          },
          on: {
            "load-items": _vm.setLinkedDevicesTotalCountItems
          }
        })];
      },
      proxy: true
    }, {
      key: "healthStateExpertModeMetricCodeEditor",
      fn: function (slotProps) {
        return [_c('code', [_vm._v("function (params) {")]), _c('codemirror', {
          staticClass: "elevation-3",
          attrs: {
            "value": _vm.get(slotProps.item, slotProps.field.key),
            "options": _vm.cmOptions
          },
          on: {
            "input": slotProps.emitInput
          }
        }), _c('code', [_vm._v("}")])];
      }
    }, {
      key: "accountSelector",
      fn: function () {
        return [_c('core-account-selector', {
          attrs: {
            "clearable": !_vm.pageIsReadOnly,
            "readonly": _vm.editMode !== _vm.EDIT_MODE.CREATE,
            "hide-details": ""
          },
          model: {
            value: _vm.accountId,
            callback: function ($$v) {
              _vm.accountId = $$v;
            },
            expression: "accountId"
          }
        })];
      },
      proxy: true
    }])
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DeviceDriver.details.prompts.copy.title'),
      "open": _vm.showCopyPrompt,
      "buttons": [{
        text: _vm.$i18n_t('DeviceDriver.details.prompts.copy.buttons.close'),
        emit: 'close'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.showCopyPrompt = false;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DeviceDriver.details.prompts.copy.text')) + "\n  ")]), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.title', {
        count: _vm.linkedDevicesTotalCount
      }),
      "open": _vm.showHealthSyncPrompt,
      "buttons": _vm.syncHealthToVDPromptButtons
    },
    on: {
      "close": function ($event) {
        _vm.showHealthSyncPrompt = false;
      },
      "sync": _vm.syncHealthStates
    }
  }, [_vm._v("\n    " + _vm._s(_vm.driverIsChanged ? _vm.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.text.isChanged') : _vm.$i18n_t('DeviceDriver.details.prompts.syncHealthToVD.text.default', {
    count: _vm.linkedDevicesTotalCount
  })) + "\n  ")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };